"use client"

import { useTranslations } from "next-intl"

/**
 * "Guarda este pedido" en la confirmación. Hermano del WalletSaveButton: no
 * decide NADA — el servidor que creó la orden acuñó el link (o null) y aquí
 * solo se pinta. Sin `navigator`, sin `useEffect`, probable con
 * renderToStaticMarkup.
 *
 * Va en los tokens de Redy (rojo + carbón) y no en el acento del restaurante:
 * la cuenta es de Redy y cruza locales, igual que el pase. Se distingue del
 * pase (carbón sólido) por ser una tarjeta clara con el CTA en carbón.
 */
export function AccountClaimCard({ url }: { url: string | null }) {
  const t = useTranslations("public.onlineOrder.checkout")
  if (!url) return null

  return (
    <a
      href={url}
      className="block w-full overflow-hidden rounded-2xl border transition hover:opacity-95 active:scale-[0.99]"
      style={{ borderColor: "var(--redy-border)", backgroundColor: "var(--redy-surface)" }}
    >
      <div className="px-5 pt-5 pb-4">
        <p
          className="text-[10.5px] font-bold uppercase tracking-[0.2em]"
          style={{ color: "var(--redy-red)" }}
        >
          {t("accountClaimLabel")}
        </p>
        <p
          className="mt-1.5 text-[17px] font-extrabold leading-tight"
          style={{ color: "var(--redy-charcoal)" }}
        >
          {t("accountClaimTitle")}
        </p>
      </div>
      <div className="px-4 pb-4">
        <span
          className="block rounded-xl px-4 py-3.5 text-center text-[15px] font-bold leading-tight text-white"
          style={{ backgroundColor: "var(--redy-charcoal)" }}
        >
          {t("accountClaimCta")}
        </span>
        <span
          className="mt-2.5 block px-1 text-center text-[12px] leading-snug"
          style={{ color: "var(--redy-muted)" }}
        >
          {t("accountClaimHint")}
        </span>
      </div>
    </a>
  )
}
